import React from 'react';
import './styles.css';

const Footer = () => (
  <footer className='footer-container'>
    <p>NCDC Toll-free Number: 080097000010</p>
    <p>Disclaimer: We protect your data and only give NCDC to prioritize emergencies</p>
    <p>&copy; DSC-UI 2020</p>
  </footer>
);

export default Footer;
